/*
 * Custom Nav — Hamburger & Search label
 */

document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('hamburgerToggle');
  if (!toggle) return;
  var nav = toggle.closest('.custom-nav__hamburger-menu').querySelector('.custom-nav__hamburger-nav');
  if (!nav) return;

  function open() {
    toggle.classList.add('is-active');
    nav.classList.add('is-open');
    document.body.classList.add('nav-open');
  }
  function close() {
    toggle.classList.remove('is-active');
    nav.classList.remove('is-open');
    document.body.classList.remove('nav-open');
  }

  toggle.addEventListener('click', function () {
    nav.classList.contains('is-open') ? close() : open();
  });
  nav.addEventListener('click', function (e) {
    if (e.target === nav) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
  });

  /* Search label — click to open the search modal */
  var searchLabel = document.querySelector('.custom-nav__search-label');
  if (searchLabel) {
    searchLabel.addEventListener('click', function () {
      var summary = searchLabel.closest('.custom-nav__search').querySelector('details summary');
      if (summary) summary.click();
    });
  }
});